import { heroStats, guideIndex } from "@/mocks/home";

export default function Hero() {
  return (
    <section id="top" className="w-full bg-background-50 pt-28 md:pt-36 pb-16 md:pb-24">
      <div className="w-full max-w-6xl mx-auto px-4 md:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-[1.15fr_0.85fr] gap-12 lg:gap-16 items-start">
          <div className="animate-fade-up">
            <span className="inline-flex items-center gap-2 text-xs text-secondary-800 bg-secondary-100 px-3 py-1.5 rounded-full">
              <i className="ri-bookmark-3-line"></i>
              下载指引 · 长期更新
            </span>

            <h1 className="mt-6 font-heading text-3xl md:text-5xl leading-snug md:leading-tight text-foreground-950">
              茄子视频下载怎么找？
            </h1>

            <p className="mt-5 text-base md:text-lg leading-relaxed text-foreground-700 max-w-xl">
              官方入口、最新地址与 APP 安装步骤，这里一次性讲清楚。找不到网址、装不上、打不开这些常见问题，
              看完这一页基本就有答案了。
            </p>

            <div className="mt-8 flex flex-col sm:flex-row gap-3">
              <a
                href="#entry"
                className="px-6 py-3 rounded-md text-sm text-center bg-primary-500 text-background-50 hover:bg-primary-600 transition-colors whitespace-nowrap"
              >
                查看下载入口
              </a>
              <a
                href="#install"
                className="px-6 py-3 rounded-md text-sm text-center border border-foreground-300 text-foreground-800 hover:border-primary-400 hover:text-primary-700 transition-colors whitespace-nowrap"
              >
                阅读安装教程
              </a>
            </div>

            <dl className="mt-12 grid grid-cols-3 gap-6 max-w-lg">
              {heroStats.map((stat) => (
                <div key={stat.id} className="border-t border-background-300 pt-4">
                  <dt className="text-xs text-foreground-500">{stat.label}</dt>
                  <dd className="mt-1 font-heading text-2xl text-foreground-950">
                    {stat.value}
                    <span className="text-sm text-foreground-600 ml-1">{stat.unit}</span>
                  </dd>
                </div>
              ))}
            </dl>
          </div>

          <aside className="animate-fade-up [animation-delay:140ms]">
            <div className="rounded-lg border border-background-200 bg-background-100 p-5 md:p-6">
              <div className="flex items-center justify-between">
                <h2 className="font-heading text-base text-foreground-950">本页内容索引</h2>
                <span className="w-8 h-8 rounded-md bg-accent-100 text-accent-700 flex items-center justify-center">
                  <i className="ri-list-check-2 text-base"></i>
                </span>
              </div>

              <ul className="mt-4 divide-y divide-background-200">
                {guideIndex.map((item, i) => (
                  <li key={item.id}>
                    <a href={item.href} className="group flex items-start gap-3 py-3.5">
                      <span className="mt-0.5 w-6 h-6 shrink-0 rounded-md bg-background-50 border border-background-300 text-[11px] text-foreground-600 flex items-center justify-center">
                        {i + 1}
                      </span>
                      <span className="min-w-0">
                        <span className="block text-sm text-foreground-900 group-hover:text-primary-700 transition-colors">
                          {item.label}
                        </span>
                        <span className="block text-xs text-foreground-500 mt-0.5">{item.desc}</span>
                      </span>
                      <i className="ri-arrow-right-s-line ml-auto mt-0.5 text-foreground-400 group-hover:text-primary-600 transition-colors"></i>
                    </a>
                  </li>
                ))}
              </ul>
            </div>
          </aside>
        </div>
      </div>
    </section>
  );
}